import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { useTranslation } from "@redotech/redo-i18n";
export function DeadlineCard({ deadlineDays }: { deadlineDays: number }) {
  const { t } = useTranslation();
  return (
    <Flex flexDirection="column" gap="sm">
      <Text fontWeight="bold">{t("Deadline")}</Text>
      <Text>
        {t("You must ship your package within {{deadlineDays}} days.", {
          deadlineDays,
        })}
      </Text>
    </Flex>
  );
}
